import { FAQSection } from "./faq";
import { Hero } from "./hero";
import Markets from "./Markets";
import OneStop from "./oneStop";
import { OurProduct } from "./ourProduct";
import Trends from "./Trends";
import { UseCases } from "./useCases";
import ValueProposition from "./valueProposition";
import { WhyChoseAI } from "./whyChose";
import { Helmet, HelmetData } from "react-helmet-async";

export default function NewHomePage() {
  const helmetData = new HelmetData({});
  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>Analytics Intelligence Ltd | Enterprise AI &amp; Analytics Solutions</title>
        <link rel="canonical" href="https://analyticsintelligence.com/" />
        <meta
          name="description"
          content="Analytics Intelligence Ltd delivers enterprise analytics platforms, AI infrastructure for banking and fintech, and cloud AI solutions globally — serving organisations across Africa, the UK, Europe, North America, and beyond."
        />
        <meta
          name="keywords"
          content="Analytics Intelligence, Analytics Intelligence Ltd, Analytics Intelligence AI, Analytics Intelligence Banking, Analytics Intelligence Fintech, artificial intelligence solutions, AI for banking, enterprise analytics platform, business intelligence solutions, AI infrastructure, predictive analytics for financial services, data analytics consulting, AI compliance solutions, machine learning for banks, cloud AI platform, AI infrastructure for banks in Africa, banking analytics solutions in Mauritius, AI compliance for financial institutions, predictive analytics for risk management, AI fraud detection platform Africa, regulatory reporting automation with AI, data governance solutions for banks, AI inference infrastructure Africa, AI company in Mauritius, analytics firm in Port Louis, data analytics company in Africa, fintech AI solutions Mauritius, banking AI SSA, Analytics Intelligence Mauritius"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Analytics Intelligence Ltd" />
        <meta property="og:title" content="Analytics Intelligence Ltd | Enterprise AI & Analytics Solutions" />
        <meta property="og:description" content="Enterprise analytics platforms, AI infrastructure for banking and fintech, and cloud AI solutions — serving organisations globally across Africa, Europe, North America, and beyond." />
        <meta property="og:url" content="https://analyticsintelligence.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://analyticsintelligence.com/favicon.png" />
        <meta property="og:site_name" content="Analytics Intelligence" />
        <meta property="og:locale" content="en_GB" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@_AnalyticsIntel" />
        <meta name="twitter:title" content="Analytics Intelligence Ltd | Enterprise AI & Analytics Solutions" />
        <meta name="twitter:description" content="Enterprise analytics platforms, AI infrastructure for banking and fintech, and cloud AI solutions — serving organisations globally across Africa, Europe, North America, and beyond." />
        <meta name="twitter:image" content="https://analyticsintelligence.com/favicon.png" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "name": "Analytics Intelligence Ltd",
                "alternateName": ["Analytics Intelligence", "Analytics Intelligence AI", "Analytics Intelligence Mauritius", "[AI]"],
                "url": "https://analyticsintelligence.com",
                "logo": "https://analyticsintelligence.com/favicon.png",
                "description": "Analytics Intelligence Ltd is a global AI and analytics company delivering enterprise analytics platforms, AI infrastructure for banking and fintech, cloud AI solutions, and predictive analytics for financial services — with reach across Africa, the United Kingdom, Europe, North America, South America, and Australia.",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Port Louis",
                  "addressCountry": "MU"
                },
                "areaServed": ["Africa", "United Kingdom", "Europe", "North America", "South America", "Australia", "Mauritius"],
                "knowsAbout": ["AI for Banking", "Predictive Analytics for Financial Services", "Enterprise Analytics Platform", "Business Intelligence Solutions", "AI Infrastructure", "AI Compliance Solutions", "Machine Learning for Banks", "Cloud AI Platform", "Data Analytics Consulting", "Fintech AI Solutions", "AI Fraud Detection", "Regulatory Reporting Automation"]
              },
              {
                "@type": "LocalBusiness",
                "name": "Analytics Intelligence Ltd",
                "description": "Global AI and analytics company serving banking, fintech, and enterprise organisations worldwide, registered in Mauritius.",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Port Louis",
                  "addressCountry": "MU"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": -20.1654,
                  "longitude": 57.4991
                },
                "url": "https://analyticsintelligence.com",
                "areaServed": ["Africa", "United Kingdom", "Europe", "North America", "South America", "Australia", "Mauritius"]
              },
              {
                "@type": "WebSite",
                "url": "https://analyticsintelligence.com",
                "name": "Analytics Intelligence",
                "description": "Enterprise AI and analytics solutions by Analytics Intelligence Ltd.",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "https://analyticsintelligence.com/blog?search={query}",
                  "query-input": "required name=query"
                }
              }
            ]
          }
        `}</script>
      </Helmet>

      <main>
        <Hero />
        <ValueProposition />
        <OurProduct />
        <Markets />
        <WhyChoseAI />
        <UseCases />
        <Trends />
        <OneStop />
        <FAQSection />
      </main>
    </>
  );
}
